module.exports = __webpack_public_path__ + "static/media/vertigenius.0f83f4d2.png";